var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FieldAlert, FlexBox, InputText, Modal, ModalBody, ModalFoot, ModalHead, Text, } from '@dixa/lib-shared-habla';
import { useCallback, useState } from 'react';
import { ratingApi } from 'apis/rating';
import { isResponseWithData } from 'utils/apis/axios';
import { createAppModal } from 'utils/modal';
import { useAppNavigate } from 'utils/url/useAppNavigate';
import styles from './surveyAddModal.module.scss';
/** A component that displays a add survey modal. */
export const SurveyAddModal = createAppModal({ type: 'settings:addSurvey' }, ({ isOpen, hide }) => {
    const [surveyName, setSurveyName] = useState();
    const [error, setError] = useState('');
    const navigate = useAppNavigate();
    const handleCreateRatingSettings = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const createResponse = yield createRatingSettings({
                level: 'survey',
                name: surveyName,
                survey_type: 'text_to_speech',
            }).unwrap();
            if (isResponseWithData(createResponse)) {
                handleClose();
                handleGoToSurvey(createResponse.data.id);
            }
        }
        catch (e) {
            const error = e;
            if (error.status === 409) {
                setError('Survey name already exists');
            }
            else if (error.data.errors) {
                setError(error.data.errors.join('. '));
            }
            else {
                setError('Something went wrong');
            }
        }
    }), [navigate, surveyName]);
    /** Handles closing the modal. */
    const handleClose = () => {
        setSurveyName(undefined);
        hide === null || hide === void 0 ? void 0 : hide();
    };
    const handleGoToSurvey = useCallback((settingsId) => {
        navigate({
            path: '/settings/satisfaction/phone/survey/:settingsId',
            params: { path: { settingsId } },
        });
    }, [navigate]);
    const [createRatingSettings] = ratingApi.useLazyCreateRatingSettingsQuery();
    return (_jsxs(Modal, Object.assign({ isOpen: isOpen, onClose: handleClose, className: styles.modal }, { children: [_jsx(ModalHead, { title: _jsx(FlexBox, Object.assign({ gap: "200" }, { children: _jsx(Text.Heading, { children: "Add survey" }) })), onClose: handleClose }), _jsx(ModalBody, { children: _jsx(FlexBox, Object.assign({ flexDirection: "column", gap: "400" }, { children: _jsxs(FlexBox, Object.assign({ flexDirection: "column", gap: "300" }, { children: [_jsx(Text.Paragraph, Object.assign({ variant: "3" }, { children: "CSAT survey name" })), _jsx(InputText, { name: "csat survey name", placeholder: "Survey name", value: surveyName, onChange: (e) => {
                                    setSurveyName(e.target.value);
                                    setError('');
                                }, type: "text", status: error ? 'error' : undefined }), error && _jsx(FieldAlert, Object.assign({ variant: "error" }, { children: error }))] })) })) }), _jsx(ModalFoot, { cancelOnClick: handleClose, confirmName: "Add", confirmOnClick: () => surveyName && handleCreateRatingSettings(), confirmProps: {
                    disabled: !surveyName,
                } })] })));
});
